import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Orcamento from "@/pages/Orcamento";

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-ink">
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/servicos/:slug" element={<ServicePage />} />
                    <Route path="/orcamento" element={<Orcamento />} />
                    <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
                <WhatsAppFloat />
                <Toaster position="bottom-center" theme="dark" />
            </BrowserRouter>
        </div>
    );
}

export default App;
